'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter("gissler", function (stringUtils, $translate) {
  return function gisslerFilter(value) {
    if (value == null) {
      return "";
    }
    if (value.indice === 'HORS_CHARTE' || value.structure === 'HORS_CHARTE') {
      return $translate("lov.structuresGissler.HORS_CHARTE");
    }
    return $translate('lov.structuresGissler.' + value.structure) + $translate('lov.indicesGissler.' + value.indice);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/gissler-filters.js
// module id = 2703
// module chunks = 13